import { render, staticRenderFns } from "./MemberCompanyTab.vue?vue&type=template&id=1e163b41&"
import script from "./MemberCompanyTab.vue?vue&type=script&lang=js&"
export * from "./MemberCompanyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports